import axios from "axios"

/**
 * Map a raw payment error to the user-facing toast subtitle (Figma:
 * Card_Payment_Error_Toast → "Please retry or check your balance").
 *
 * Every axios/HTTP error — decline, 424 insufficient balance, network, 5xx — surfaces
 * as this single designed line. The opaque "Request failed with status code N" is never
 * user-facing, and bank decline reason-codes are unreliable (a fraud hold reported as
 * "insufficient funds" makes a user who KNOWS they have funds distrust us), so we don't
 * assert a specific cause. Our own thrown Errors already carry a readable message, so
 * those pass through.
 */
export function paymentErrorMessage(
  err: unknown,
  fallback = "Please retry or check your balance",
): string {
  if (axios.isAxiosError(err)) return fallback
  return err instanceof Error ? err.message : fallback
}
